function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSezione05Popup0301Ico02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75.25 75.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M65.53,40.56c0,4.06-3.29,7.34-7.34,7.34s-7.34-3.29-7.34-7.34,3.29-7.34,7.34-7.34,7.34,3.29,7.34,7.34ZM30.28,49.37c0,4.06,3.29,7.34,7.34,7.34s7.34-3.29,7.34-7.34-3.29-7.34-7.34-7.34-7.34,3.29-7.34,7.34Z",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinejoin: "round",
      strokeWidth: "1.83px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.79,59.65v8.81M68.46,59.65v8.81M47.9,68.46v5.87M27.35,68.46v5.87M50.84,50.84l7.34,7.34,7.34-7.34,4.79,1.6c2.4.8,4.02,3.04,4.02,5.57v10.45M53.78,74.34v-7.51c0-2.53-1.62-4.77-4.02-5.57l-4.79-1.6-7.34,7.34-7.34-7.34-4.8,1.6c-2.4.8-4.02,3.04-4.02,5.57v7.51",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.83px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.07,
    cy: 40.56,
    r: 7.34,
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinejoin: "round",
      strokeWidth: "1.83px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.56,12.66l-2.94,2.94-2.94-2.94M37.63,15.6v8.81M43.5,24.41c2.27-3.09,5.87-6.13,5.87-11.75,0-6.49-5.26-11.75-11.75-11.75s-11.75,5.26-11.75,11.75c0,5.62,3.6,8.66,5.87,11.75h11.75ZM56.7,23.68l-3.81-2.2M22.37,3.85l-3.82-2.2M18.55,23.68l3.82-2.2M52.89,3.85l3.81-2.2M14.13,12.66h5.87M55.25,12.66h5.87M40.56,33.22h-5.87c-1.62,0-2.94-1.31-2.94-2.94v-5.87h11.75v5.87c0,1.62-1.31,2.94-2.94,2.94ZM24.41,50.84l-7.34,7.34-7.34-7.34-4.79,1.6c-2.4.8-4.02,3.04-4.02,5.57v10.45",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.83px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSezione05Popup0301Ico02);
export default __webpack_public_path__ + "static/media/sezione-05-popup-03-01-ico-02.5b9882365ef69dedacabe64fb2dbb92d.svg";
export { ForwardRef as ReactComponent };